import React from 'react';
import { ColourTheme } from '../../../../types/ColourTheme';
import i18n from 'i18next';
import { convertNumericKeysToArray } from '../../../../newHelpers/convertNumericKeysToArray';
import { personaToReportImg, carrotReportHero } from './PersonaReportImageMap';
import './PersonaReport.scss';
import { StoreContext } from '../../../../store/StoreContext';
import { stylize } from '../../../../newHelpers/stylize';

type Props = {
  theme: ColourTheme;
};

export const PersonaReport = (props: Props) => {
  const copy: Copy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.report`, { returnObjects: true }));
  const dnaCopy: Copy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.DNAconsult`, { returnObjects: true }));
  return (
    <div className="PersonaReport">
      <h2>{stylize(copy.title)}</h2>
      {(props.theme === ColourTheme.carrot) &&
        <div className="carrot-hero">
          <img src={carrotReportHero} alt={`${props.theme}-img`} />
        </div>
      }
      <div className="wrapper">
        <div className="left-container">
          <div>
            <StoreContext.Consumer>
              {
                store =>
                  <img src={personaToReportImg[store.currentLanguage][props.theme]} alt={`${props.theme}-suggested-report`} />
              }
            </StoreContext.Consumer>
          </div>
        </div>
        <div className="right-container">
          {copy.p?.map((item, index) =>
            <p key={index}>{item}</p>
          )}
        </div>
      </div>
      {(props.theme === ColourTheme.sunflower) &&
        <div className="wrapper">
          <div className="left-container">
            <div>
              <h2 className="dna-title">{dnaCopy.title}</h2>
            </div>
          </div>
          <div className="right-container">
            {dnaCopy.p?.map((item, index) =>
              <p key={index}>{item}</p>
            )}
          </div>
        </div>
      }
      {(props.theme === ColourTheme.carrot) &&
        <h2 className="carrot-quote">{i18n.t(`${props.theme}Landing.quote2.p`)}</h2>
      }
    </div>
  );
};

type Copy = {
  title: string;
  p: string[];
};
